import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { UXPContext } from '@core/context/Context';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render shows the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // Log error details if needed
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    render() {
        var _a;
        if (this.state.hasError) {
            const errorMessage = ((_a = this.context) === null || _a === void 0 ? void 0 : _a.$L)
                ? _jsxs(_Fragment, { children: [this.context.$L('uxp-core.text.aw-snap'), " ", _jsx("br", {}), this.context.$L('uxp-core.text.something-went-wrong')] })
                : "Aw snap! Something went wrong.";
            return (_jsxs("div", { className: "widget-placeholder-block", children: [_jsxs("div", { className: "header", children: [_jsx("div", { className: "icon" }), _jsx("div", { className: "text" })] }), _jsx("div", { className: "content", children: [...Array(3)].map((_, i) => (_jsxs("div", { className: "para", children: [_jsx("div", { className: "text" }), _jsx("div", { className: "text" })] }, i))) }), _jsxs("div", { className: "placeholder error-block", children: [_jsx("div", { className: "icon-placeholder", children: _jsx("div", { className: "icon" }) }), _jsx("div", { className: "text", children: errorMessage })] })] }));
        }
        return this.props.children;
    }
}
ErrorBoundary.contextType = UXPContext;
export default ErrorBoundary;
